import React, { useEffect, useRef, useState } from "react";

const AnimatedText = ({ text, className = "", Tag = "h3" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <Tag className={className} ref={ref}>
      {text.split(" ").map((word, wi) => (
        <span key={wi}>
          {word.split("").map((letter, li) => (
            <span
              key={li}
              className={`animated-letter ${visible ? "show" : ""}`}
              style={{
                transitionDelay: `${wi * 200 + li * 30}ms`,
              }}
            >
              {letter}
            </span>
          ))}
          {" "}
        </span>
      ))}
    </Tag>
  );
};

export default AnimatedText;
